module.exports = __webpack_public_path__ + "img/amentum-logo.1093359e.svg";